import { Component, ViewEncapsulation, Input, OnDestroy, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { ProviderService } from '../../../services/provider.service';
//import { ClientService } from '../../../services/client.service';
//import { BusinessService } from '../../../services/business.service';
//import { ListPriceService } from '../../../services/list-price.service';
@Component({
    selector: 'app-edit-provider',
    templateUrl: 'editProviderModal.component.html',
    styleUrls: ['./editProviderModal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ProviderService]
})
export class EditarProviderModalComponent implements OnDestroy {
    editProvider: any = {};
    modalTitle = '';
    buttonText = '';
    subscription: Subscription;
    action: string;
    comision: number;
    respuesta: boolean;
    //listAlterBussinessAddress = [];
    //showBusinessName = false;
    //business: IBusiness = {};
    //listPrices = [];
    constructor(public dialogRef: MatDialogRef<EditarProviderModalComponent>,
        private providerService: ProviderService,
        private notifierService: NotifierService,
        private zone: NgZone
    ) {
        //this.editUser.tipoUsuario = '';
        this.respuesta = true;
        this.editProvider.comercial_name = '';
        this.handleNotify();
        /*this.listPriceService.getListPrices().subscribe((result: Array<any>) => {
            this.listPrices = [{}, ...result];
        });*/

    }

    handleNotify() {
        this.subscription = this.notifierService.behaviorNotifierObject$.subscribe(
            message => {
                this.zone.run(() => {
                    console.log(message);
                    this.action = message.action;
                    // tslint:disable-next-line:triple-equals
                    if (message.action == 'edit' && message.model == 'provider') {
                        /*this.businessService.getAllBusiness(message.object.id).subscribe((listBusiness: Array<IBusiness>) => {
                            this.listAlterBussinessAddress = listBusiness;
                        });*/
                        this.editProvider = message.object;
                        /*if (this.editUser.comision) {
                            this.comision = this.editUser.comision * 100;
                        }*/
                        this.buttonText = 'Actualizar';
                        this.modalTitle = 'Editar Proveedor';
                        // tslint:disable-next-line:triple-equals
                    } else if (message.action == 'register' && message.model == 'provider') {
                        this.editProvider = message.object;
                        this.buttonText = 'Crear';
                        this.modalTitle = 'Crear Proveedor';
                    }
                });

            }
        );
    }
    MaysPrimera(string){
        return string.charAt(0).toUpperCase() + string.slice(1);
      }



      
 expresionRegularNombreComercial(phoneInput) {
    var re = /^[A-Z]{1}[\s/.a-zñ0-9-&/%/.@]{1}([\s/.A-Za-zñ0-9-&/%/.@]+)*$/;
  var OK = re.exec(phoneInput);
  if (OK) {
       this.respuesta=true;
   

  } else {
     this.respuesta=false;
    this.notifierService.systemNotify({
        title: 'Ha ocurrido un error',
        message: 'El campo Nombre comercial no puede comenzar con 2 mayusculas',
        type: 'error'
    });
}
} 

    update() {
        //this.editUser.comision = this.comision / 100;
        this.expresionRegularNombreComercial(this.editProvider.comercial_name);

        if(this.respuesta===true){
        this.providerService.updateProvider(this.editProvider.id,this.editProvider).subscribe((result) => {
            this.notifierService.systemNotify({
                title: 'Actualizacion Completada',
                message: 'El usuario se ha Actualizado con exito',
                type: 'success'
            });
            this.dialogRef.close();
            
        }, (error) => {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor póngase en contacto con el administrador' ,
                type: 'error'
            });
            this.dialogRef.close();
        });
    }
    }

    create() {
        this.expresionRegularNombreComercial(this.editProvider.comercial_name);

        if(this.respuesta===true){
        this.providerService.createProvider(this.editProvider).subscribe((result) => {
            this.notifierService.systemNotify({
                title: 'Éxito',
                message: 'El Proveedor se ha creado exitosamente',
                type: 'success'
            });
            this.dialogRef.close();
            
        }, (error) => {

            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor póngase en contacto con el administrador. ' + error.error.message,
                type: 'error'
            });
            this.dialogRef.close();
        });
    }
    }

    close() {
        this.dialogRef.close();
    }

    /*showAdminBusinessName() {
        this.showBusinessName = !this.showBusinessName;
    }

    deleteAlterBussiness(item: IBusiness) {
        this.businessService.DeleteBussines(item.id);
    }

    saveBusiness() {
        this.business.id_client = this.editUser.id;
        this.businessService.InsertBussiness(this.business).subscribe(result => {

        });
    }*/

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}

/*export interface IBusiness {
    id?: number;
    tenant?: string;
    name?: string;
    ruc?: string;
    email?: string;
    id_client?: number;
    address?: string;
}*/



// WEBPACK FOOTER //
// ./src/app/system/provider/modals/editProvider/editProviderModal.component.ts